import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { useQuery } from '@tanstack/react-query';
import { formAPI } from 'api/form';
import { Box } from '@mui/material';
import NodeCssElement from 'app/app/editor/tabs/elements/layout/NodeCssElement';

export default function NodeCssElements({
    node,
    uid,
    componentUid,
}: {
    node: any;
    uid: string | null;
    componentUid: string | null;
}) {
    const { t } = useBundleTranslation();
    const ctx = useAppBuilderContext();
    const [page] = [ctx.page];

    const component = null !== node.params?.uid && page?.components[node.params?.uid];
    const { status, data } = useQuery<any, Error>({
        queryKey: [component ? component.component : '', 'styles.json'],
        queryFn: () =>
            component ? formAPI.load('/data/app/components/' + component.component + '/styles.json') : null,
    });

    if (status === 'pending') return <Box>{t('loading___')}</Box>;
    else if (status === 'error') return <Box>{t('error___')}</Box>;

    if (!data || !data.data || !data.data.elements) return <></>;

    return (
        <>
            {uid !== null && componentUid !== null && (
                <NodeCssElement element={data.data} uid={uid} componentUid={componentUid} />
            )}
        </>
    );
}
